import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import { IconAttention, IconWatches } from '../svg'

const Banner = ({ padding, variant, reason_id, reason_data, t }) => {
    let history = useHistory()

    function onClick_link({ path, state }) {
        history.push(path, { state })
    }

    function Text() {
        switch (reason_id) {
            case 1: {
                return t('_components._banner.text_1')
            }
            case 2: {
                return t('_components._banner.text_new', { current: reason_data.current, total: reason_data.total })
            }
            default:
                return ''
        }
    }

    return (
        <div className="banner" data-padding={padding} data-variant={variant}>
            <div className="banner-box container-fluid">
                <div>
                    {reason_id === 1 || reason_id === 2 ? (
                        <span className="icon" data-icon="attention">
                            <IconAttention />
                        </span>
                    ) : null}
                    <div className="text">{<Text />}</div>
                </div>
                {reason_id === 1 ? (
                    <button
                        className="button"
                        data-size="md"
                        data-variant="primary--inverse"
                        onClick={() => onClick_link({ path: '/account/billing-and-payments?tab=subscription' })}
                        data-test="renew-subscription"
                    >
                        {t('_components._banner.renew_subscription')}
                    </button>
                ) : null}
                {reason_id === 2 ? (
                    <button
                        className="button"
                        data-size="md"
                        data-variant="primary--inverse"
                        onClick={() => onClick_link({ path: '/account/billing-and-payments?tab=subscription' })}
                        data-test="upgrade-subscription"
                    >
                        {t('_components._banner.upgrade_your_plan')}
                    </button>
                ) : null}
            </div>
        </div>
    )
}

export default withTranslation('translations')(Banner)
